module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card faq-block"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showFaq),
      expression: "showFaq"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Typ hier uw vraag of zoekterm"
    },
    domProps: {
      "value": (_vm.showFaq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.showFaq = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showFaq.length > 0) ? _c('button', {
    staticClass: "clear",
    on: {
      "click": _vm.clearInput
    }
  }, [_vm._v("x")]) : _vm._e()])]), _vm._v(" "), (_vm.showFaq) ? _c('div', {
    staticClass: "card-block"
  }, [(_vm.showNoAnswers) ? _c('div', [_vm._v("Helaas, we hebben geen antwoord op uw vraag. Typ een ander trefwoord of neem contact met ons op.")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "faq"
  }, _vm._l((_vm.totalFaqs), function(faq) {
    return _c('li', {
      key: faq
    }, [_c('p', {
      staticClass: "question",
      class: {
        open: faq.isOpen
      },
      on: {
        "click": function($event) {
          faq.isOpen = !faq.isOpen
        }
      }
    }, [_c('span', {
      staticClass: "category"
    }, [_vm._v(_vm._s(faq.categorie))]), _c('span', {
      staticClass: "line",
      domProps: {
        "innerHTML": _vm._s(faq.vraag)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "answer",
      domProps: {
        "innerHTML": _vm._s(faq.antwoord)
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(faq.antwoord)
      }
    })])])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('span', [_c('span', {
    staticClass: "hexagon-border"
  }, [_vm._v("?")]), _vm._v("\r\n\t\t\tStel uw vraag\r\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e0841d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/faqs.vue
// module id = 100
// module chunks = 0